import Head from "next/head";
import Image from "next/image";

/* eslint-disable @next/next/no-html-link-for-pages */

export default function FourOhFour() {
    return (
        <div>
            <Head>
                {/* <!-- IE only --> */}
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

                <meta name="viewport" content="width=device-width, initial-scale=1" />

                {/* <!-- Stop IPad treating numbers as links --> */}
                <meta name="format-detection" content="telephone=no" />

                {/* <!-- Title Content --> */}
                <title>An error occurred</title>

                {/* <!-- Meta Description Link --> */}
                <meta name="description" content="This page is no longer available" />
            </Head>

            <div id="ErrorDiv">
                {/* <!-- logo left side div --> */}
                <div className="errorPageDividerline">
                    <div>
                        <div style={{ textAlign: "center" }}>
                            <div className="errorlogo">
                                <a href="/">
                                    <Image
                                        src="https://images.motorpoint.co.uk/logos/motorpoint/primary.svg"
                                        alt="Motorpoint logo"
                                        width={500}
                                        height={155}
                                    ></Image>
                                </a>
                            </div>
                            <h1>This page was not found</h1>
                            <p>
                                Please click back, or click <a href="/">here</a> to go to the home
                                page.
                                <br />
                                <br />
                                For enquiries please call:
                                <br />
                                <span className="phone googleNumber">01332 227 227</span>
                            </p>
                            <p>
                                Our customer advisors are available:
                                <br />
                                <strong>
                                    <span className="openhours">
                                        <span className="openhoursday">Monday - Friday</span>
                                        <span className="openhourstime"> 8:30am - 8pm</span>
                                        <br />
                                        <span className="openhoursday">Saturday</span>
                                        <span className="openhourstime"> 9am - 6pm</span>
                                        <br />
                                        <span className="openhoursday">Sunday</span>
                                        <span className="openhourstime"> 10am - 5pm</span>
                                        <br />
                                    </span>
                                </strong>
                            </p>
                            <p>
                                You can either call us during these times or send us an enquiry via
                                email to
                                <br />
                                <a className="email" href="mailto:sales@motorpoint.co.uk">
                                    sales@motorpoint.co.uk
                                </a>
                                <br />
                                <br />
                                If you would like us to call you, email us your phone number let us
                                know a time that&apos;s convenient for you and we&apos;ll happily
                                call you back.
                                <br />
                                <br />
                            </p>
                        </div>
                        <div className="error-image">
                            <Image
                                src="https://images.motorpoint.co.uk/images/404image.png"
                                alt="404"
                                layout="fill"
                            ></Image>
                        </div>
                        <div className="bottomlinks">
                            <p>
                                <a href="/">Motorpoint Home</a> |{" "}
                                <a href="/used-cars">Browse Cars</a> |{" "}
                                <a href="/car-finance">Finance</a> | <a href="/stores">Stores</a>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="error-message">Error 404 - Page Not Found</div>

                <style jsx>{`
                    .errorPageDividerline {
                        padding: 20px;
                    }

                    .errorlogo {
                        max-width: 500px;
                        margin: 0 auto 30px;
                    }

                    #ErrorDiv h1 {
                        font-size: 21px;
                        line-height: 28px;
                        margin: 20px 0;
                        font-weight: 500;
                    }

                    #ErrorDiv {
                        max-width: 600px;
                        margin: 30px auto 0;
                        line-height: 24px;
                    }

                    #ErrorDiv a {
                        color: #fff;
                        text-decoration: underline;
                    }

                    .phone {
                        font-size: 26px;
                        line-height: 16px;
                        font-weight: 500;
                        margin-top: 15px;
                    }

                    .email {
                        padding: 10px;
                    }

                    .bottomlinks {
                        text-align: center;
                    }

                    .bottomlinks a {
                        padding: 10px;
                    }

                    .error-message {
                        text-align: center;
                        font-size: 12px;
                        color: #aaaaaa;
                    }

                    .error-image {
                        height: 120px;
                        width: 200px;
                        margin: 0 auto 30px;
                    }

                    .error-image img {
                        margin: 0 auto;
                        display: block;
                        width: 200px;
                        margin-bottom: 25px;
                    }

                    .openhours {
                        font-weight: 500;
                        margin-top: 10px;
                    }
                `}</style>

                <style global jsx>{`
                    body {
                        background: #004996;
                        color: #fff;
                    }
                `}</style>
            </div>
        </div>
    );
}
